import React, { useState, useEffect } from "react";
import { MATERIALCATALOG_API, ASSET_ACCESSORY_API } from "@app/utils/apiUrl";
import { Post, Get } from "@app/utils/httpProvider";
import Modal from 'react-bootstrap/Modal';

const AccessoryAddModal = ({ show, assetId, onClose, onSave }) => {
    const [errors, setErrors] = useState({});
    const [materialList, setMaterialList] = useState([]);

    const [formData, setFormData] = useState({
        materialId: "", 
        materialCode: "",
        materialName: "",
        specification: "",
        unit: "",
        description: "",
        quantity: "",
        accessoryStatus: "Hoạt động",
        note: ""
    });

    useEffect(() => {
        const fetchMaterials = async () => {
            try {
                const data = await Get(`${MATERIALCATALOG_API.GET_ALL}`);
                setMaterialList(data || []);
            } catch (err) {
                console.error("Lỗi load MaterialCatalog:", err);
            }
        };

        if (show) {
            fetchMaterials();
        }
    }, [show]);

    // 1. CẬP NHẬT HÀM VALIDATE
    const validateForm = () => {
        const newErrors = {};

        // Validation Tên phụ kiện (Dựa vào materialId)
        if (!formData.materialId) {
            newErrors.materialId = "Vui lòng chọn tên phụ kiện.";
        }

        // Validation Số lượng
        if (!formData.quantity) {
            newErrors.quantity = "Vui lòng nhập số lượng.";
        } else if (Number(formData.quantity) <= 0) {
            newErrors.quantity = "Số lượng phải lớn hơn 0.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Xóa lỗi khi người dùng bắt đầu nhập lại
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        try {
            const accessoryPayload = {
                assetId: parseInt(assetId),
                materialId: Number(formData.materialId),
                quantity: Number(formData.quantity),
                accessoryStatus: formData.accessoryStatus,
                note: formData.note,
                isDeleted: false
            };

            const accessoryRes = await Post(`${ASSET_ACCESSORY_API.ADD_ITEM}`, null, accessoryPayload);

            if (!accessoryRes.ok) {
                throw new Error("Tạo AssetAccessory thất bại");
            }

            const accessoryData = await accessoryRes.json();

            if (onSave) {
                onSave(accessoryData);
            }

            // reset form
            handleCancel();

        } catch (error) {
            console.error(error);
            alert(error.message || "Đã có lỗi xảy ra khi thêm phụ kiện");
        }
    };

    const handleCancel = () => {
        setFormData({
            materialId: "",
            materialCode: "",
            materialName: "",
            specification: "",
            unit: "",
            description: "",
            quantity: "",
            accessoryStatus: "Hoạt động",
            note: ""
        });
        setErrors({});
        if (onClose) {
            onClose();
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleCancel}
            size="md"
            animation={true}
            centered
        >
            <Modal.Header>
                <Modal.Title className="font-weight-bold">
                    Thêm phụ kiện
                </Modal.Title>
                <button
                    type="button"
                    className="close"
                    onClick={handleCancel}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>

            <Modal.Body className="p-4">
                <div className="container-fluid px-0">

                    {/* Row 1 - Tên phụ kiện */}
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label className="font-weight-bold mb-1">
                                Tên phụ kiện <span className="text-danger">*</span>
                            </label>
                            <select
                                className={`form-control ${errors.materialId ? 'is-invalid' : ''}`}
                                value={formData.materialId}
                                onChange={(e) => {
                                    const selectedId = parseInt(e.target.value);
                                    const selected = materialList.find(m => m.id === selectedId);

                                    setFormData(prev => ({
                                        ...prev,
                                        materialId: selectedId || "",
                                        materialCode: selected?.materialCode || "",
                                        materialName: selected?.materialName || "",
                                        specification: selected?.specification || "",
                                        unit: selected?.unit || "",
                                        description: selected?.description || ""
                                    }));
                                    
                                    // Xóa lỗi khi người dùng đã chọn
                                    if (errors.materialId) {
                                        setErrors(prev => ({ ...prev, materialId: null }));
                                    }
                                }}
                            >
                                <option value="">-- Chọn phụ kiện --</option>
                                {materialList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.materialName}
                                    </option>
                                ))}
                            </select>
                            {/* Hiển thị lỗi Tên phụ kiện */}
                            {errors.materialId && <div className="text-danger mt-1">{errors.materialId}</div>}
                        </div>
                    </div>

                    {/* Row 2 - Số lượng */}
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label className="font-weight-bold mb-1">
                                Số lượng <span className="text-danger">*</span>
                            </label>
                            <input
                                type="number"
                                className={`form-control ${errors.quantity ? 'is-invalid' : ''}`}
                                name="quantity"
                                value={formData.quantity}
                                onChange={handleChange}
                            />
                            {/* Hiển thị lỗi Số lượng */}
                            {errors.quantity && <div className="text-danger mt-1">{errors.quantity}</div>}
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label className="font-weight-bold mb-1">Trạng thái</label>
                            <select
                                className="form-control"
                                name="accessoryStatus"
                                value={formData.accessoryStatus}
                                onChange={handleChange}
                            >
                                <option value="Hoạt động">Hoạt động</option>
                                <option value="Không hoạt động">Không hoạt động</option>
                            </select>
                        </div>
                    </div>

                    {/* Row 3 - Ghi chú */}
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label className="font-weight-bold mb-1">Ghi chú</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                name="note"
                                value={formData.note}
                                onChange={handleChange}
                            ></textarea>
                        </div>
                    </div>

                </div>
            </Modal.Body>

            <Modal.Footer className="justify-content-center">
                <button
                    className="btn btn-primary mr-2"
                    onClick={handleSubmit}
                >
                    Lưu phụ kiện
                </button>
                <button
                    className="btn btn-secondary"
                    onClick={handleCancel}
                >
                    Huỷ
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default AccessoryAddModal;